// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Shared hero H1 (HomePage .mh-hero, Collective intro, etc.)
 * Collective: .mcp2-intro h1 is more specific than .mh-hero__title alone — include both selectors.
 */

.mh-hero__title,
.mcp2-intro h1.mh-hero__title {
  font-family: fabulosa, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: clamp(3rem, 6vw, 5.5rem);
  line-height: 0.95;
  color: rgba(255, 255, 255, 0.92);
  margin: 0 0 26px;
  text-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  /* Override .mcp2-intro h1 eyebrow styling when this class is used */
  text-transform: none;
  letter-spacing: normal;
}

.mh-hero__title::first-letter,
.mcp2-intro h1.mh-hero__title::first-letter {
  font-feature-settings: "init" 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/MamahoodHeroTitle.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;EAEE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,2CAA2C;EAC3C,oEAAoE;EACpE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;AACjC","sourcesContent":["/*\n * Shared hero H1 (HomePage .mh-hero, Collective intro, etc.)\n * Collective: .mcp2-intro h1 is more specific than .mh-hero__title alone — include both selectors.\n */\n\n.mh-hero__title,\n.mcp2-intro h1.mh-hero__title {\n  font-family: fabulosa, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: clamp(3rem, 6vw, 5.5rem);\n  line-height: 0.95;\n  color: rgba(255, 255, 255, 0.92);\n  margin: 0 0 26px;\n  text-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n  /* Override .mcp2-intro h1 eyebrow styling when this class is used */\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.mh-hero__title::first-letter,\n.mcp2-intro h1.mh-hero__title::first-letter {\n  font-feature-settings: \"init\" 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
